import compact from 'lodash/compact';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as DiscoveryActions from '../actions';
import * as D from '../deps';
import { getBrowseCurrentWebUrl } from '../selectors';
import * as DiscoveryServices from '../services';
import * as DiscoveryUtils from '../utils';

export function* getBrowseDirectory({ payload: { path, directoryId, offset, directoryFeedType } }) {
  let feedType = 'browse';
  const isNonPremiumListenerLikelyFTUX = yield select(
    D.Utils.Listener.isNonPremiumListenerLikelyFTUX,
  );
  if (isNonPremiumListenerLikelyFTUX) {
    feedType = 'browseFtux';
  }
  if (directoryFeedType) {
    feedType = directoryFeedType;
  }
  yield call(DiscoveryServices.getBrowseDirectory, {
    path,
    directoryId,
    offset,
    feedType,
  });
}

export function* redirectSuperBrowsePathIfNeeded() {
  const currentPath = yield select(D.Utils.Route.getCurrentPathnameFromState);

  if (!D.Utils.Route.isSuperBrowsePath(currentPath)) {
    return;
  }

  const browseCurrentWebUrl = yield select(getBrowseCurrentWebUrl);
  // In case browseCurrentWebUrl is falsy, we'll fallback to using the static map
  const browseMapUrl = D.Constants.Urls.superBrowseToBrowseMap[currentPath];
  const browseWebUrlPath = browseCurrentWebUrl || browseMapUrl;

  if (browseWebUrlPath && currentPath !== browseWebUrlPath) {
    yield put(push(browseWebUrlPath));
  }
}

export function* ingestBrowseDirectoryData() {
  const data = D.getPreloadedApiData();
  const browseData = DiscoveryUtils.getPreloadedBrowseData(data);

  if (!isEmpty(browseData)) {
    yield call(D.putAndWait, DiscoveryActions.ingestBrowseDirectoryData(browseData));
  }

  yield call(redirectSuperBrowsePathIfNeeded);
}

export function* onPLSGetDirectorySuccess(action) {
  const annotations = get(action, 'response.annotations', {});
  const artistIds = uniq(compact(map(annotations, 'artistId')));
  const pandoraIds = yield select(D.Utils.Entity.getPandoraIdsWithoutAnnotations, artistIds);
  // Request artist annotations for album grid item secondary links
  if (pandoraIds.length) {
    yield put(D.getInDomain('catalog.actions.annotateObjectsSimple')(pandoraIds));
  }

  yield call(redirectSuperBrowsePathIfNeeded);
}
